export default __webpack_public_path__ + "static/media/user-accout.8d4327b8.svg";